import React from 'react';
import { Route, Redirect } from 'react-router';
import Authentication from './authentication';

export default class PrivateRoute extends React.Component {

  state = {
    round: 0
  };

  mounted = false;

  componentDidMount() {
    this.mounted = true;
    this.unregister = Authentication.onAuthenticationChange(() => {
      return new Promise((resolve) => {
        if (!this.unregister || !this.mounted) {
          return resolve();
        }
        this.setState((state) => ({
          round: state.round + 1
        }), resolve)
      });
    });
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.unregister instanceof Function) {
      this.unregister();
      this.unregister = null;
    }
  }

  render() {
    const { component: Component, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={
          (props) => (
            Authentication.isAuthenticated() ? (
              <Component {...props}/>
            ) : (
              <Redirect
                to={{
                  pathname: '/login',
                  state: { from: props.location }
                }}
              />
            )
          )
        }
      />
    );
  }

}


// WEBPACK FOOTER //
// ./src/private-route.js